/* eslint-disable react/no-danger */
import React, { useState, useEffect } from 'react';
// import CollapseText from '../../UI/CollapseText';

const TabAbout = ({ descriptionInfo }) => {
  // eslint-disable-next-line no-unused-vars
  const [htmlDescription, handleHtmlDescription] = useState('');

  useEffect(() => {
    handleHtmlDescription(descriptionInfo);

    // console.log('htmlDescription > ', htmlDescription);
    // console.log('descriptionInfo > ', descriptionInfo);
  }, [descriptionInfo]);

  return (
    <div className="product__additional__tab">
      <div className="product__additional__tab__container">
        <div className="descriptionInfo" dangerouslySetInnerHTML={{ __html: descriptionInfo }} />
        {/*{descriptionInfo}*/}
        {/* <div> */}
        {/*  <ul> */}
        {/*    <li> Without his parents consent they</li> */}
        {/*    <li> the killers — had bombarded</li> */}
        {/*    <li> */}
        {/*      " " */}
        {/*      the unique nodule which had formed in his brain, had attacked it */}
        {/*      with radioactive cobalt. */}
        {/*    </li> */}
        {/*    <li> */}
        {/*      " " */}
        {/*      It had been a pit of corpses and dead bones and he had struggled */}
        {/*      for years to get up from it. */}
        {/*    </li> */}
        {/*  </ul> */}
        {/* </div> */}
        {/* <div> */}
        {/*  <CollapseText collapsedHeight={70}> */}
        {/*    <p> */}
        {/*      A merry little surge of */}
        {/*      {' '} */}
        {/*      <b>electricity piped</b> */}
        {/*      {' '} */}
        {/*      by automatic */}
        {/*      alarm from the mood organ beside his bed awakened Rick Deckard. */}
        {/*      Surprised — it always surprised him to find himself awake without */}
        {/*      prior notice — he rose from the bed, stood up in his" " */}
        {/*      <b>multicolored pajamas,</b> */}
        {/*      {' '} */}
        {/*      and stretched. Now, in her bed, his */}
        {/*      wife Iran opened her gray, unmerry eyes, blinked, then groaned and */}
        {/*      shut her eyes again. A merry little surge of" " */}
        {/*      <b>electricity piped</b> */}
        {/*      {' '} */}
        {/*      by automatic alarm from the mood organ */}
        {/*      beside his bed awakened Rick Deckard. Surprised — it always */}
        {/*      surprised him to find himself awake without prior notice — he rose */}
        {/*      from the bed, stood up in his */}
        {/*      <b>multicolored pajamas,</b> */}
        {/*      {' '} */}
        {/*      and */}
        {/*      stretched. Now, in her bed, his wife Iran opened her gray, unmerry */}
        {/*      eyes, blinked, then groaned and shut her eyes again. A merry */}
        {/*      little surge of */}
        {/*      <b>electricity piped</b> */}
        {/*      {' '} */}
        {/*      by automatic alarm from */}
        {/*      the mood organ beside his bed awakened Rick Deckard. Surprised — */}
        {/*      it always surprised him to find himself awake without prior notice */}
        {/*      — he rose from the bed, stood up in his" " */}
        {/*      <b>multicolored pajamas,</b> */}
        {/*      {' '} */}
        {/*      and stretched. Now, in her bed, his */}
        {/*      wife Iran opened her gray, unmerry eyes, blinked, then groaned and */}
        {/*      shut her eyes again. A merry little surge of" " */}
        {/*      <b>electricity piped</b> */}
        {/*      {' '} */}
        {/*      by automatic alarm from the mood organ */}
        {/*      beside his bed awakened Rick Deckard. Surprised — it always */}
        {/*      surprised him to find himself awake without prior notice — he rose */}
        {/*      from the bed, stood up in his */}
        {/*      <b>multicolored pajamas,</b> */}
        {/*      {' '} */}
        {/*      and */}
        {/*      stretched. Now, in her bed, his wife Iran opened her gray, unmerry */}
        {/*      eyes, blinked, then groaned and shut her eyes again. */}
        {/*    </p> */}
        {/*  </CollapseText> */}
        {/* </div> */}
      </div>
    </div>
  );
};

export default TabAbout;
